import React, { useEffect, useState } from "react";
import PromotionCard from "../shared/promotionCard";
import TransactionIcon from "../constants/assests/image/promotionIcon.png";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../reduxStore/store";
import { getCoupons } from "../models/couponSlice";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import Header from "../shared/header";
import LoadingIndicator from "../shared/loadingIndicator";
import EmptyData from "../shared/emptyData";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

function Transaction() {
  // const coupons = useSelector((state: RootState) => state.coupon.coupons);
  // const loading = useSelector((state: RootState) => state.coupon.loading);

  // const dispatch: AppDispatch = useDispatch();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const couponsData = await dispatch(getCoupons()).unwrap();
  //       console.log("User data fetched successfully:", couponsData);
  //     } catch (error) {
  //       console.error("Error fetching user data:", error);
  //     }
  //   };

  //   fetchData();
  // }, [dispatch]);

  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchCustomerHistory(currentPage);
  }, [currentPage]);

  const fetchCustomerHistory = async (page: number) => {
    setLoading(true);
    try {
      // Retrieve the token from local storage
      const token = localStorage.getItem("accessToken");
      console.log("Transaction Token " + token);
      const apiUrl = process.env.REACT_APP_API_URL;
       const shop_domain = localStorage.getItem('shop_domain');
      const response = await fetch(
        `${apiUrl}${shop_domain}/api/v1/coupons?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
          },
        }
      );
      const result = await response.json();
      setData(result.data.data);
      setTotalPages(result.data.last_page);
    } catch (error) {
      console.error("Error fetching customer history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const navigate = useNavigate();

  const handleCouponClick = (couponId: string) => {
    navigate("/Promotionconfirm", { state: { couponId } });
  };

  return (
    <div className="flex flex-col w-full h-screen bg-bright-ashe">
      {/* Header */}
      <div className="fixed top-0 z-10">
      <a href="/homePage">
      <Header icon={<KeyboardArrowLeftIcon />} name="Redeem Points" />
      </a>
      </div>

      {/* Content */}
      <div className="flex flex-col w-full p-5 mt-12 pb-20 bg-bright-ashe ">
          {loading ? (
            <LoadingIndicator />
          ) : data.length > 0 ? (
            data.map((coupon) => (
              <div  key={coupon.id}>
                <div
                  onClick={() => handleCouponClick(coupon.id)}
                  className="cursor-pointer"
                >
                  <PromotionCard
                    header={coupon.title}
                    description={coupon.end_date}
                    src={TransactionIcon}
                    footerText={coupon.points}
                  />
                </div>
              </div>
            ))
          ) : (
            <EmptyData />
          )}
        </div>

      {/* Pagination */}
      <div className="flex justify-center py-3 fixed bottom-0 bg-white w-full border-t border-gray-200">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="text-slate-600 font-thin px-4"
        >
          <KeyboardArrowLeftIcon />
        </button>
        <span className="text-sm font-semibold pt-1">Page {currentPage}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="text-slate-600 font-thin px-4"
        >
          <KeyboardArrowRightIcon />
        </button>
      </div>
    </div>
  );
}

export default Transaction;
